export const onSortValue = ['treatment_name', 'Status', 'Contact'];

export const TAB_HEAD = [
    { value: 'All', label: 'All' },
    { value: 'NEW', label: 'New' },
    { value: 'CONSULTATION_BOOKED', label: 'Booked' },
    { value: 'CONSULTATION_ATTENDED', label: 'Attended' },
    { value: 'TREATMENT_STARTED', label: 'Started' },
    { value: 'FAILED_TO_ATTEND_CONSULTATION', label: 'FTA' },
    { value: 'CLOSED', label: 'Completed' }
];

export const TAB_HEAD_FOLLOW_UP = [
    { value: 'All', label: 'All' },
    { value: 'NEW', label: 'New' },
    { value: 'FOLLOW_UP', label: 'Follow up' },
    { value: 'CONSULTATION_BOOKED', label: 'Booked' },
    { value: 'CONSULTATION_ATTENDED', label: 'Attended' },
    { value: 'TREATMENT_STARTED', label: 'Started' },
    { value: 'FAILED_TO_ATTEND_CONSULTATION', label: 'FTA' },
    { value: 'CLOSED', label: 'Completed' }
];

export const TAB_HEAD_NO_TASK = [
    { value: 'NEW', label: 'New' },
    { value: 'FOLLOW_UP', label: 'Follow up' },
    { value: 'CONSULTATION_BOOKED', label: 'Booked' },
    { value: 'CONSULTATION_ATTENDED', label: 'Attended' },
    { value: 'FAILED_TO_ATTEND_CONSULTATION', label: 'FTA' },
];

export const NEW_TAB_HEAD = [
    { value: '0', label: 'New' },
    { value: '1', label: 'Follow up 1' },
    { value: '2', label: 'Follow up 2' },
    { value: '3', label: 'Follow up 3 +' },
];

export const DASHBOARD_WIDGET_COUNTER = [
    { key: '1', status: 'NEW', isDate: true, healthCareProvider: 'PRIVATE', hasNewOrNullTreatment: true },
    // v2FollowUpStage: on tasks-v2 practices this widget counts V2 tasks scoped to
    // NEW-stage lead_treatments (getTaskWidgetCounter), and the click lands on the
    // tasks-v2 board pre-filtered to NEW. On V1 practices the v2FollowUpStage flag
    // is ignored and the legacy /reminders/ count (group__in/completedFilter/…) runs.
    { key: '2', v2FollowUpStage: 'NEW', group__in: true, completedFilter: true, isTaskDateTimeRange: true, shouldGetTaskCounter: true, is_completed: false, dateFilters: 'Today' },
    // Keys '3' (Consultations booked, shouldGetReportCounter) and '5' (ClinCheck) removed
    // 2026-06-11: they were fetched on every dashboard load but never rendered. The dashboard
    // ActionCards (GeneralApp buildActionCards) render only keys 2,4,7,1,6,BOOKED_AWAITING.
    // DashBoardReportsWidget (AllLeadsTable/InterPractice only) reads 'BOOKED_LEADS'/
    // 'FAILED_TO_ATTEND_LEADS' from DASHBOARD_REPORTS_WIDGET_COUNTER — separate array,
    // not loaded here. No consumer read '3'/'5' → wasted requests removed.
    // Counter arrays for the report/clincheck TABLES are unaffected (separate keys).
    // v2FollowUpStage: on tasks-v2 practices this widget counts V2 tasks scoped to
    // CONSULTATION_ATTENDED-stage lead_treatments (getTaskWidgetCounter), and the
    // click lands on the tasks-v2 board pre-filtered to CONSULTATION_ATTENDED. On V1
    // practices the v2FollowUpStage flag is ignored and the existing lead-based count
    // (status/contactedCountForStatus/isAppointmentDate via getWidgetCounter) runs,
    // with its current attended-table pre-filtered click.
    { key: '4', v2FollowUpStage: 'CONSULTATION_ATTENDED', status: 'CONSULTATION_ATTENDED', isAppointmentDate: true, contactedCountForStatus: '0,exact,CONSULTATION_ATTENDED' },
    { key: '6', status: 'FAILED_TO_ATTEND_CONSULTATION' },
    { key: 'BOOKED_AWAITING', status: 'CONSULTATION_BOOKED', appStatus: 'BOOKED', pastNoOutcome: true },
    // key '7' (Pending WhatsApps) is populated by fetchUnreadWhatsAppCount() in whatsappV2.js
    // — do NOT add it here or it will race-overwrite the real WhatsApp thread counts.
];

// Lead-based BOOKED + FAILED_TO_ATTEND counts for DashBoardReportsWidget only.
//
// Intentionally NOT in DASHBOARD_WIDGET_COUNTER: that array fires for every practice
// on every main-dashboard load (GeneralApp.jsx ~L428), but DashBoardReportsWidget only
// renders inside AllLeadsTable / InterPractice (NewLead type='Dashboard'). Adding the
// entries here would fire two extra count queries globally for a widget only these two
// pages need.
//
// Keys use a _LEADS suffix rather than sharing 'BOOKED'/'FAILED_TO_ATTEND' with
// analytics.js getCounter (~L652). That path writes the bare keys with inflated
// appointment-record counts (one per appointment visit, not per lead) when the
// Reports page is visited. Without key isolation, a Reports → AllLeadsTable
// navigation (no GeneralApp remount to re-fire DASHBOARD_WIDGET_COUNTER) would
// leave stale appointment-based counts on the widget until the next full reload.
// Separate keys eliminate the race entirely.
//
// AllLeadsTable and InterPractice fire this array on mount alongside
// DASHBOARD_WIDGET_COUNTER; DashBoardReportsWidget reads _LEADS keys.
export const DASHBOARD_REPORTS_WIDGET_COUNTER = [
    { key: 'BOOKED_LEADS', status: 'CONSULTATION_BOOKED' },
    { key: 'FAILED_TO_ATTEND_LEADS', status: 'FAILED_TO_ATTEND_CONSULTATION' },
];

// appStatus: 'ATTENDED' was used here to narrow badge counts to leads that have a
// specifically-attended appointment record. The leads table click path (getNewLead)
// does not accept an appointments__status filter, so this dimension cannot be
// threaded through to the table view. Removed from badge configs for keys 2-5 so
// the badge count matches what the table shows on click (treatment filter only).
// Kept as a named const in case a future API version supports the filter.
const appointmentDataAttendedTable = {};

// Actionable widget counters for Consultation Booked table
export const BOOKED_TABLE_WIDGET_COUNTER = [
    { key: 'upcoming', status: 'CONSULTATION_BOOKED', appStatus: 'BOOKED', upcomingThisWeek: true },
    { key: 'past', status: 'CONSULTATION_BOOKED', appStatus: 'BOOKED', pastNoOutcome: true },
];
export const STARTED_TABLE_WIDGET_COUNTER = [
    { key: '1', treatmentStatusForPrice: 'TREATMENT_STARTED', treatmentPrice: true },
    { key: '2', status: 'TREATMENT_STARTED', treatment: 'invisalign' },
    { key: '3', status: 'TREATMENT_STARTED', treatment: 'bonding' },
    { key: '4', status: 'TREATMENT_STARTED', treatment: 'implants' },
    { key: '5', status: 'TREATMENT_STARTED', treatment: 'whitening' },
    { key: '6', status: 'TREATMENT_STARTED', appStatus: 'BOOKED', isAppointmentDate: true },
    { key: '7', status: 'TREATMENT_STARTED', treatment: 'veneers' },
    { key: '8', status: 'TREATMENT_STARTED', treatment: 'all on 4' },
    { key: '9', status: 'TREATMENT_STARTED', treatment: 'teeth straightening' },
    { key: '10', status: 'TREATMENT_STARTED', treatment: 'fixed braces' },
];
export const FTA_TABLE_WIDGET_COUNTER = [
    { key: '1', status: 'FAILED_TO_ATTEND_CONSULTATION' },
    { key: '2', status: 'FAILED_TO_ATTEND_CONSULTATION', treatment: 'invisalign' },
    { key: '3', status: 'FAILED_TO_ATTEND_CONSULTATION', treatment: 'bonding' },
    { key: '4', status: 'FAILED_TO_ATTEND_CONSULTATION', treatment: 'implants' },
];
export const ATTENDED_TABLE_WIDGET_COUNTER = [
    { key: '1', status: 'CONSULTATION_ATTENDED', contactedCountForStatus: '0,exact,CONSULTATION_ATTENDED', attendedFlatMode: true },
    { key: '2', status: 'CONSULTATION_ATTENDED', treatment: 'invisalign', attendedFlatMode: true, ...appointmentDataAttendedTable },
    { key: '3', status: 'CONSULTATION_ATTENDED', treatment: 'bonding', attendedFlatMode: true, ...appointmentDataAttendedTable },
    { key: '4', status: 'CONSULTATION_ATTENDED', treatment: 'implants', attendedFlatMode: true, ...appointmentDataAttendedTable },
    { key: '5', status: 'CONSULTATION_ATTENDED', treatment: 'whitening', attendedFlatMode: true, ...appointmentDataAttendedTable },
    { key: '6', treatmentStatusForPrice: 'CONSULTATION_ATTENDED', shouldGetPrice: true, attendedFlatMode: true },
];
// CLINCHECK_TABLE_WIDGET_COUNTER was removed: zero importers outside this file
// (grep confirmed). The ClinCheck table widget uses isClinCheckTable: true flags
// on ATTENDED_TABLE_WIDGET_COUNTER entries instead — no separate array needed.

export const CONSULTANT_NEW_ATTENDED_HEAD = [
    { value: '0', label: 'New' },
    { value: '1', label: 'Follow up 1' },
    { value: '2', label: 'Follow up 2' },
    { value: '3', label: 'Follow up 3 +' },
];

// Single "All Attended" tab — used by the ConsultantAttend table to show every attended
// lead regardless of contacted-count. Kept separate from CONSULTANT_NEW_ATTENDED_HEAD so
// that NHSLead.jsx and tasksV2.js (which spread the original 4-entry array) are unaffected.
export const CONSULTANT_ATTENDED_SINGLE_HEAD = [{ value: 'All', label: 'All Attended' }];

// Shared query-string builder for the attended contacted-count filter.
// Emits status-scoped params so only contacts logged during CONSULTATION_ATTENDED
// are matched — prevents false positives from cross-status count rows.
// Consumed by: ConsultantAttend.jsx (fallback) and NewLead.jsx (useAttendedScope branch).
export const buildAttendedCountFilterQuery = (val) => {
    if (!val) return '';
    if (val === '3+') return '&contacted_count_for_status=3,gte,CONSULTATION_ATTENDED';
    return `&contacted_count_for_status=${val},exact,CONSULTATION_ATTENDED`;
};

export const CONSULTANT_CLINCHECK_ATTENDED_HEAD = [];

export const ATTENDED_CHECKLISTS_HEAD = [];

export const ATTENDED_CHECKLISTS_TAB_HEAD = [
    // HOTFIX 2026-06-09: 'All' is the default sub-tab so checklist-bound custom tabs
    // show every lead that matches the tab's treatment/binding scope — not just leads
    // whose checklist_state=in_progress. Earlier default ('in_progress') hid leads
    // that had no checklist row at all (e.g. lead 170414: only an Automations email
    // task, no checklist rows → checklist_state=none → excluded). Empty value maps to
    // "no checklist_state param" in coreThunks.getNewLead (line ~293) and getCounter
    // (line ~775). Sub-tabs below still let users filter explicitly.
    { value: '', label: 'All' },
    { value: 'in_progress', label: 'In Progress' },
    // Canonical BE value is 'complete' (apps/leads/filters.py VALID_CHECKLIST_STATES =
    // {'complete','in_progress','none'}). Strip value is the BE value directly — single
    // source of truth, no FE-side 'completed'→'complete' normalization anywhere.
    // AttendedTabContextualWidget also uses 'complete' for FOLLOW_UP_COMPLETE click-through —
    // keep in sync if this value ever changes in VALID_CHECKLIST_STATES.
    { value: 'complete', label: 'Follow-Up Complete' },
];

// Dashboard V2 board checklist strip — no 'All' tab.
// 'In Progress' is the default with exhaustive semantics: BE checklist_state_exhaustive=true
// means IP = all non-complete leads (including unchecklisted + no-treatment).
// Attended surfaces (ConsultantAttend / AttendedChecklists / TreatmentStarted) keep
// ATTENDED_CHECKLISTS_TAB_HEAD (with All) and their non-exhaustive filtering unchanged.
// DEPLOY ORDER: BE checklist_state_exhaustive must be live before this is promoted.
export const DASH_V2_CHECKLIST_TAB_HEAD = [
    { value: 'in_progress', label: 'In Progress' },
    { value: 'complete', label: 'Follow-Up Complete' },
];

// Mitigation LIFTED 2026-05-27: BE #9 (checklist-state COUNT query optimisation) is in
// production.  The count query (limit=1&checklist_state=in_progress|complete) now returns
// in ~100-200 ms (measured on prod: p18 Wokingham 14/12, p26 DentalKind 8/2).
// Setting this back to false re-enables the existing getCounter path for the "In Progress"
// and "Follow-Up Complete" checklist sub-tabs (same mechanism as Follow-up 1/2/3; no new
// logic — the counter wiring already exists, it was only gated by this flag).
// Original suppression reason: task #10 / feature_fix-leads-tab-refire (ERR_ABORTED storm).
export const SUPPRESS_CHECKLIST_TAB_COUNTERS = false;

export const CONSULTANT_BOOKED_HEAD = [];

export const DASH_NEW_HEADER = [
    { value: '0', label: 'New' },
    { value: 'NHS', label: 'NHS' },
    { value: 'AWAITING_RESPONSE', label: 'Waiting/Scheduled' },
    { value: '1', label: 'Follow up 1' },
    { value: '2', label: 'Follow up 2' },
    { value: '3', label: 'Follow up 3 +' },
];
// notification
export const NOTIFICATION_HEAD = [
    { id: '' },
    { id: 'description', label: 'Description', sort: '' },
    { id: 'timestamp', label: 'Timestamp', sort: '' },
    { id: '' },
];

export const NOTIFICATION_HEAD_SETTING = [
    { id: 'notify', label: 'Notify', sort: '' },
    { id: 'platform', label: 'Platform', sort: '', checkbox: true },
    { id: 'email', label: 'Email', sort: '', checkbox: true },
    { id: 'sms', label: 'SMS', sort: '', checkbox: true },
    { id: '' },
];

export const DATE_TITLES = [
    {
        label: 'Date',
        value: 'date_format',
        icon: 'solar:calendar-mark-bold-duotone'
    },
    {
        label: 'Time',
        value: 'human_readable',
        icon: 'uim:clock'
    },
    {
        label: 'Date & Time',
        value: 'date_time_format',
        icon: 'mdi:calendar-clock'
    },
];

export const COLOR_CODES = [
    '#D1E9FC',
    '#76B0F1',
    '#2065D1',
    '#103996',
    '#061B64',
    '#EFD6FF',
    '#C684FF',
    '#8E33FF',
    '#5119B7',
    '#27097A',
    '#CAFDF5',
    '#61F3F3',
    '#00B8D9',
    '#006C9C',
    '#003768',
    '#D3FCD2',
    '#77ED8B',
    '#22C55E',
    '#118D57',
    '#065E49',
    '#FFF5CC',
    '#FFD666',
    '#FFAB00',
    '#B76E00',
    '#7A4100',
    '#FFE9D5',
    '#FFAC82',
    '#FF5630',
    '#B71D18',
    '#7A0916',
    '#F9FAFB',
    '#F4F6F8',
    '#DFE3E8',
    '#C4CDD5',
    '#919EAB',
    '#6E7E91',
];

export const startedTreatmentColumns = ['treatment', 'price', 'status', 'lead_treatments__appointments__datetime', 'booked_with', 'actions',];
export const bookedAttendedColumns = ['treatment', 'price', 'status', 'deposit_pending', 'app_method', 'app_type', 'lead_treatments__appointments__datetime', 'actions'];
export const commonColumns = ['treatment', 'status', 'price', 'actions'];
